import { OidcPaths } from 'Feature/Auth/Constant/OidcPaths';
import { LandingPaths } from 'Feature/Common/Common/Constant/LandingPaths';
import { WepodGenderTypeEnum } from 'Feature/Common/Common/Types/Enums/WepodGenderTypeEnum';
import Consts from 'Framework/Consts';
import { IUserManagerConfig } from 'Shared/User/Models/IUserManagerConfig';
import { gregorianDate } from 'Shared/Utils/Extensions/String/StringExtensions';
import moment from 'jalali-moment';

const userConfigs: IUserManagerConfig = {
  ssoURL: Consts.env.REACT_APP_SSO_APP_BASE_URL ?? '',
  ssoAuthorizationEndpoint: Consts.env.REACT_APP_SSO_APP_AUTHORIZATION_ENDPOINT ?? '',
  ssoTokenEndpoint: Consts.env.REACT_APP_SSO_APP_TOKEN_ENDPOINT ?? '',
  ssoUserInfoEndpoint: Consts.env.REACT_APP_SSO_APP_USERINFO_ENDPOINT ?? '',
  ssoSignOutEndpoint: Consts.env.REACT_APP_SSO_APP_SIGNOUT_ENDPOINT ?? '',
  ssoClinetId: Consts.env.REACT_APP_SSO_CLIENT_ID ?? '',
  ssoScopes: Consts.env.REACT_APP_SSO_SCOPES ?? '',
  ssoSecret: Consts.env.REACT_APP_SSO_SECRET ?? '',
  disablePKCE: Consts.env.REACT_APP_SSO_DISABLE_PKCE ?? undefined,
  wepodURL: Consts.env.REACT_APP_WEPOD_URL ?? '',
  mainAddress: LandingPaths.Landing.Main ?? '',
  signInCallback: OidcPaths.Oidc.SignInCallback ?? '',
  signOutCallBack: OidcPaths.Oidc.SignOutCallBack ?? '',
  silentCallback: OidcPaths.Oidc.SilentCallback ?? '',
  autoLogin: OidcPaths.Oidc.AutoLogin ?? '',
  melliatId: Consts.env.REACT_APP_MELLIAT_ID ?? '' ?? '',
  isReal: Consts.env.REACT_APP_IS_REAL === 'true',
  exchangeUrl: Consts.env.REACT_APP_SSO_EXCHANGE_URL ?? '',
  renewUrl: Consts.env.REACT_APP_SSO_RENEW_URL ?? '',

  userMapper(user) {
    return {
      firstName: String(user?.profile.given_name),
      lastName: String(user?.profile.family_name),
      codeMelli: String(user?.profile.legalInfo.nationalCode),
      id: String(user?.profile.id),

      shenasehMelli: '',
      ostanName: '',
      meliatId: Consts.env.REACT_APP_MELLIAT_ID,

      isReal: Consts.env.REACT_APP_IS_REAL === 'true',
      jensiat: WepodGenderTypeEnum[Number(user?.profile.legalInfo.gender)]?.toString(),
      expired: Boolean(user?.expired),
      cityName: user?.profile.legalInfo.officeName,
      cityCode: user?.profile.legalInfo.officeCode,
      birthday: moment
        .utc(gregorianDate(user?.profile.birthdate, 'MM/DD/YYYY') ?? '', 'MM/DD/YYYY')
        .toDate()
        ?.toString(),
      birthDate: moment.utc(gregorianDate(user?.profile.birthdate, 'MM/DD/YYYY') ?? '', 'MM/DD/YYYY').toDate(),
      mobile: String(user?.profile?.phone_number),
      picture: user?.profile?.picture,
    };
  },
};

export default userConfigs;
